import { FC } from 'react'
import { DropdownButton } from 'shared/components/Dropdown/DropdownButton'
import { BackButton } from 'shared/components/BackButton'
import { Icon } from 'shared/components/Icons'
import {
    HeaderContentItem,
    HeaderContainer,
    StyledDeleteButton,
} from './styles'
import { CollapseButton } from 'shared/components/CollapseButton'

interface HeaderProps {
    handleCloseSidebar: () => void
    handleForceCloseSidebar: () => void
    onDeleteOrder: () => void
    isPreview: boolean
    isHistory: boolean
    goFromPreviewToEdit: () => void
    onRemoveBooking: () => void
    onGoToPaymentRedirectUrl: () => void
    onGoToPayment: () => void
    onGoRefund: () => void
    goToHistory: () => void
    isPaid: boolean
    isPastBooking: boolean
    isOrderExist: boolean
}

export const Header: FC<HeaderProps> = ({
    isPreview,
    isHistory,
    goFromPreviewToEdit,
    handleCloseSidebar,
    handleForceCloseSidebar,
    onDeleteOrder,
    onRemoveBooking,
    onGoToPaymentRedirectUrl,
    onGoToPayment,
    onGoRefund,
    goToHistory,
    isPaid,
    // isPastBooking,
    isOrderExist,
}) => {
    const allButtons = [
        {
            title: 'История редактирования',
            onClick: goToHistory,
            isHide: isHistory,
        },
        {
            title: 'Редактировать бронь',
            onClick: goFromPreviewToEdit,
            // isHide: isPastBooking,
        },
        {
            title: 'Возврат',
            onClick: onGoRefund,
            isHide: !isPaid,
        },
        {
            title: 'Оплатить',
            onClick: onGoToPayment,
            isHide: isPaid,
        },
        {
            title: 'Ссылка на оплату',
            onClick: onGoToPaymentRedirectUrl,
            isHide: !isPaid,
        },
        {
            title: 'Удалить бронирование',
            isErrorColor: true,
            onClick: onRemoveBooking,
        },
        {
            title: 'Удалить заказ',
            isErrorColor: true,
            onClick: onDeleteOrder,
        },
    ]
    const buttonsWithCheck = allButtons.filter(btn => !btn.isHide)

    return (
        <HeaderContainer>
            <HeaderContentItem>
                <div className='wrapper'>
                    <BackButton text='Назад' onClick={handleCloseSidebar} />
                </div>
            </HeaderContentItem>
            <HeaderContentItem>
                {(isPreview || isHistory) && (
                    <DropdownButton buttons={buttonsWithCheck} />
                )}
                {!isPreview && isOrderExist && (
                    <StyledDeleteButton onClick={onDeleteOrder}>
                        <Icon name='delete' />
                    </StyledDeleteButton>
                )}
                {isHistory && (
                    <CollapseButton onClick={handleForceCloseSidebar} />
                )}
            </HeaderContentItem>
        </HeaderContainer>
    )
}
